import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Accountsgroup } from "./accountsgroup";
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
// import {  Accountsgroups  } from "../../../master/Accountsgroup/shared/accountsgroups";

@Injectable({
  providedIn: 'root'
})

export class AccountsgroupService {

  selectedAccountsgroup: Accountsgroup;

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {

    return environment.baseUrl;
  }

  IUDAccountsGroup(accountsgroup: Accountsgroup) {

    // accountsgroup.Id = + accountsgroup.Id;
    // accountsgroup.AccountId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    // accountsgroup.ParentAccountId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    // accountsgroup.AccountName = JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    // accountsgroup.DispalyOrder  = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    // accountsgroup.DisplayIn = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    // accountsgroup.GroupCode =  JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    // accountsgroup.Predefined  = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    // accountsgroup.IsActive = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    let body = accountsgroup;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/AccountsGroup/IUD', body, { headers: headers });
  }

  FetchVoucherList() {

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/AccountsGroup/FetchList', body, { headers: headers });
   }


}
